export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";